export enum DocumentationCategory {
  WEB = 'web',
  NATIVE = 'native',
  HOW_TO_TEST = 'how-to-test',
}
